import { GA4Event} from "./GA4Event";

export function buildAddItemFromBox(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("add_item_from_box", {
		items_in_box: attributes.items_in_box || '',
		interaction: attributes.interaction || '',
		total_rebuy_price: attributes.total_rebuy_price || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
